import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {MessageCategoryItem, MessageCategoriesState, RegexRulesItem} from './types';

export const actions: ActionTree<MessageCategoriesState, RootState> = {
    getMessageCategories: ({commit, dispatch}, data) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                url: '/acapi/message_categories', params: {
                    name: data?.name,
                    transports: Array.isArray(data?.transport) ? data?.transport?.join() : data?.transport,
                    is_default: Array.isArray(data?.is_default) ? data?.is_default?.join() : data?.is_default,
                    regex: data?.regex,
                    is_default_sms: data?.is_default_sms,
                    is_default_viber: data?.is_default_viber,
                    is_default_whatsapp: data?.is_default_whatsapp,
                }
            })
                .then(resp => {
                    commit('setMessageCategories', resp.data.message_categories);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    getMessageCategoryItem: ({commit}, id) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/message_categories/${id}`})
                .then((resp: any) => {
                    let messageCategoryItem = <MessageCategoryItem>resp.data;
                    messageCategoryItem.id = id;
                    commit('setMessageCategoryItem', messageCategoryItem);
                    resolve(messageCategoryItem)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    saveMessageCategoryItem: ({commit, dispatch}, data: MessageCategoryItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/message_categories/' + (data.id ?? ''),
                data: data
            })
                .then((resp: any) => {
                    dispatch('getMessageCategories');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    deleteMessageCategoryItem: ({commit, dispatch}, data: MessageCategoryItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/message_categories/${data.id}`,
                data: data
            })
                .then((resp: any) => {
                    dispatch('getMessageCategories');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    getAllowedTransports: ({commit, dispatch}, data) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                url: '/acapi/message_categories/allowed_transports'
            })
                .then(resp => {
                    commit('setAllowedTransports', resp.data.transport_ids);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    getRegexItem: ({commit}, id) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/message_categories/regexes/${id}`})
                .then((resp: any) => {
                    let regexRulesItem = <RegexRulesItem>resp.data;
                    regexRulesItem.id = id;
                    commit('setRegexRulesItem', regexRulesItem);
                    resolve(regexRulesItem)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    saveRegexes: ({commit, dispatch}, data: RegexRulesItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/message_categories/regexes/' + (data.id ?? ''),
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    deleteRegexRule: ({commit, dispatch}, data: RegexRulesItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/message_categories/regexes/${data.id}`,
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    saveRegexesPriority: ({commit, dispatch}, data:any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/acapi/message_categories/regexes/priority',
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
};
